import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PortalService {

  current = 'customer';

  constructor() { }

}
